<div
  [style]="data.maxwidth ? data.maxwidth : maxwidth"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle
>
  <div
    [class]="
      'flex align-items-center m-1 ' +
      (data.showCloseBtn ? 'justify-content-between' : 'justify-content-start')
    "
  >
    <div class="flex align-items-center">
      <mat-icon [color]="data.icon_color" *ngIf="data.icon" class="mb-2 mr-2">
        {{ data.icon }}
      </mat-icon>
      <h2 style="font-size: 18px">{{ data.title }}</h2>
    </div>
    <i
      class="pi pi-fw pi-times-circle text-red-500 cursor-pointer"
      (click)="matDialogRef.close({ closeDialog: true })"
      *ngIf="data.showCloseBtn"
    ></i>
  </div>
  <mat-dialog-content>
    <h6
      class="mb-2 font-weight-light"
      [style]="data.breakline ? 'white-space: pre;' : 'white-space: normal;'"
      *ngIf="data.bodyMessage"
    >
      {{ data.bodyMessage }}
    </h6>
    <div
      *ngIf="data.submsgs"
      class="p-2 w-100 h-100 overflow-auto flex flex-column justify-content-center"
      [style]="{
        height: data.contentHeightSubmsgs
          ? data.contentHeightSubmsgs + ' !important'
          : '100%'
      }"
    >
      <span
        class="text-msgs text-nowrap mb-1 text-center"
        *ngFor="let msg of data.submsgs"
      >
        <div *ngIf="!data.useAccessRouterSubMsg">
          <i class="pi pi-fw pi-caret-right fs-xsmall"></i>
          {{ msg }}
        </div>
        <div
          class="flex align-items-center justify-content-center"
          *ngIf="data.useAccessRouterSubMsg"
        >
          <div class="flex align-items-center">
            <i class="pi pi-fw pi-caret-right fs-xsmall"></i>
            <span class="font-light text-msgs ml-2">
              {{ msg.mensagem }}
            </span>
          </div>
          <button
            *ngIf="msg.toolTip"
            pButton
            pRipple
            [pTooltip]="msg.toolTip"
            (click)="sendTo(msg.link)"
            icon="pi pi-pencil"
            class="ml-2 p-button-primary p-button-rounded p-button-text"
          ></button>
        </div>
      </span>
    </div>

    <mat-tree
      [dataSource]="dataSource"
      [treeControl]="treeControl"
      *ngIf="
        data.subMsgsTree &&
        data.subMsgsTree.length !== 0 &&
        data.showMultipleMsg
      "
    >
      <mat-tree-node *matTreeNodeDef="let item" matTreeNodePadding>
        <div
          mat-line
          class="flex align-items-center justify-content-between width-100"
        >
          <div class="flex align-items-center">
            <i class="mdi mdi-circle-small mr-2"></i>
            <span>{{ item.msg_erro }}</span>
            <i
              class="ml-2 pi pi-fw pi-pencil text-primary cursor-pointer"
              *ngIf="
                item.url_validate
                  ? verificarDisponibilidade(item.url_validate)
                  : item.link
              "
              pTooltip="Visualizar cadastro!"
              (click)="sendTo(item.link)"
            ></i>
          </div>
        </div>
      </mat-tree-node>
      <mat-tree-node
        *matTreeNodeDef="let item; when: hasChild"
        matTreeNodePadding
      >
        <button
          mat-icon-button
          matTreeNodeToggle
          [attr.aria-label]="'Toggle ' + item.descricao"
        >
          <mat-icon class="mat-icon-rtl-mirror">
            {{ treeControl.isExpanded(item) ? 'expand_more' : 'chevron_right' }}
          </mat-icon>
        </button>
        <span [class]="'fs-normal ' + (item.bolder ? 'font-semibold' : '')">{{
          item.descricao
        }}</span>
        <i
          class="ml-2 pi pi-fw pi-pencil text-primary cursor-pointer"
          *ngIf="
            item.url_validate
              ? verificarDisponibilidade(item.url_validate)
              : item.link
          "
          pTooltip="Visualizar cadastro!"
          (click)="sendTo(item.link)"
        ></i>
      </mat-tree-node>
    </mat-tree>
    <h6
      class="mt-2 font-weight-bolder text-center"
      [style]="data.breakline ? 'white-space: pre;' : 'white-space: normal;'"
      *ngIf="data.subBodyMessage"
    >
      {{ data.subBodyMessage }}
    </h6>

    <div class="row mt-3 flex align-items-center justify-content-center">
      <div class="col-md-12 mt-3" *ngIf="data.usePasswordField">
        <span class="p-float-label">
          <p-password
            [formControl]="passwordControl"
            id="field-newpasswd"
            [feedback]="false"
            styleClass="p-password p-component p-inputwrapper p-input-icon-right"
            [toggleMask]="true"
          >
          </p-password>
          <label for="inputtext">Senha *</label>
        </span>
        <small class="p-error" *ngIf="passwordControl.hasError('required')">
          Obrigatório informar a senha
        </small>
        <small class="p-error" *ngIf="passwordControl.hasError('notSame')">
          As senhas não combinam
        </small>
        <small class="p-error" *ngIf="passwordControl.hasError('maxlength')">
          A senha deve conter no máximo 64 caracteres.
        </small>
        <small
          class="p-error"
          *ngIf="passwordControl.hasError('strongPassword')"
        >
          Misture letras maiúsculas, minúsculas, números e caracteres especiais.
        </small>
        <small class="p-error" *ngIf="passwordControl.hasError('isEmptyValue')">
          Valor inválido, remova os espaços em branco!
        </small>
      </div>

      <div class="col-md-12 mt-3" *ngIf="data.existsObs">
        <span class="p-float-label">
          <textarea
            rows="9"
            cols="50"
            pInputTextarea
            style="resize: none;"
            id="inputtext-descricao"
            [formControl]="observacaoFormControl"
            class="input-filters-text-area"
          ></textarea>
          <label for="inputtext-descricao">Informe uma justificativa *</label>
        </span>
        <small
          class="p-error"
          *ngIf="
            observacaoFormControl.dirty &&
            observacaoFormControl.hasError('maxlength')
          "
        >
          A justificativa deve conter no máximo 500 caracteres
        </small>
        <small
          class="p-error"
          *ngIf="
            observacaoFormControl.dirty &&
            observacaoFormControl.hasError('minlength')
          "
        >
          A justificativa deve conter no mínimo 15 caracteres
        </small>
        <small
          class="p-error"
          *ngIf="
            observacaoFormControl.dirty &&
            observacaoFormControl.hasError('required')
          "
        >
          A Justificativa é obrigatória
        </small>
      </div>

      <p-floatLabel
        class="col-md-12 mt-3 flex align-items-center justify-content-center"
        *ngIf="data.useDateField"
      >
        <p-calendar
          dateMask
          class="width-100"
          placeholder="Faixa de datas"
          selectionMode="range"
          [formControl]="keywordFormDateRange"
          appendTo="body"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          [readonlyInput]="true"
          inputId="range"
        >
        </p-calendar>
        <label for="data_hora">Data</label>
      </p-floatLabel>
      <div
        *ngIf="data.options"
        class="flex flex-column justify-content-center align-items-center"
      >
        <mat-radio-group
          *ngIf="!data.useCheckbox"
          class="flex flex-column justify-content-center align-items-center cursor-pointer"
          [(ngModel)]="selectedValue"
        >
          <mat-radio-button
            class="mt-2"
            *ngFor="let option of data.options"
            color="primary"
            [value]="option.value"
            [disabled]="option.disabled ?? false"
          >
            <span class="cursor-pointer">{{ option.label }}</span>
          </mat-radio-button>
        </mat-radio-group>

        <section
          *ngIf="data.useCheckbox"
          class="flex flex-column align-items-center align-content-center"
        >
          <mat-checkbox
            *ngFor="let option of data.options"
            [value]="option.value"
            (change)="selectCheckBox(option.value)"
            class="mt-2"
            color="primary"
            [disabled]="option.disabled ?? false"
          >
            {{ option.label }}
          </mat-checkbox>
        </section>
      </div>

      <div
        *ngIf="data.options_select"
        class="flex flex-column justify-content-center align-items-center mb-2"
      >
        <mat-form-field appearance="outline" class="width-100">
          <mat-label>{{ data.options_select_label }}</mat-label>
          <mat-select [(value)]="selectedValueOption">
            <mat-option *ngFor="let i of data.options_select" [value]="i.value">
              {{ i.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <mat-checkbox
        *ngIf="data.optionCheckBox"
        color="primary"
        class="col-md-12 mt-3"
        [formControl]="estoqueFormControl"
      >
        {{ data.labelOptionCheckBox }}
      </mat-checkbox>
    </div>
  </mat-dialog-content>

  <div
    *ngIf="data.singleBtn"
    matDialogActions
    class=" d-flex justify-content-center align-items-center mt-2 p-3"
  >
    <button
      type="button"
      mat-raised-button
      color="primary"
      id="confirm-btn"
      (click)="confirmar()"
      cdkFocusInitial
    >
      Entendi
    </button>
  </div>
  <div
    *ngIf="!data.singleBtn"
    matDialogActions
    class=" d-flex justify-content-between align-items-center mt-2 p-3"
  >
    <button
      type="button"
      mat-stroked-button
      [color]="data.colorCloseButton ? data.colorCloseButton : 'warn'"
      id="cancel-btn"
      [matDialogClose]="false"
    >
      {{ data.labelCloseButton || 'Não' }}
    </button>
    <button
      type="button"
      mat-raised-button
      [color]="data.colorConfirmButton ? data.colorConfirmButton : 'primary'"
      id="confirm-btn"
      (click)="confirmar()"
      [disabled]="disabledConfirmBtn"
      cdkFocusInitial
    >
      {{ data.labelConfirmButton || 'Sim' }}
    </button>
  </div>
</div>
